import { render } from "./FileModalSelector.vue?vue&type=template&id=15001f96&scoped=true"
import script from "./FileModalSelector.vue?vue&type=script&lang=js"
export * from "./FileModalSelector.vue?vue&type=script&lang=js"

import "./FileModalSelector.vue?vue&type=style&index=0&id=15001f96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15001f96"]])

export default __exports__